import React from "react";
import {Link} from "react-router-dom";
import NavLanguageComponent from "./NavLanguageComponent";
import NavUserComponent from "./NavUserComponent";
import NavGdprComponent from "./NavGdprComponent";
import {getStyle} from "../../services/Style";
import Navbar from "react-bootstrap/Navbar";
import {Nav} from "react-bootstrap";
import {generateJobIconUrl} from "../../services/ApiService";
import '../css/Banner.scss';
import PropTypes from "prop-types";

export default class Banner extends React.Component {

    static propTypes = {
        customerName: PropTypes.string.isRequired,
        language: PropTypes.string.isRequired,
        customerData: PropTypes.objectOf(Promise).isRequired,
        link: PropTypes.string,
		positionId: PropTypes.oneOf([PropTypes.string, PropTypes.number]),
        userName: PropTypes.string
    };

    static defaultProps = {
        link: null
    };

    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            title: null,
        };
        this.loadData();
    }

    getStyle = (className) =>
    {
        return getStyle(this.props.positionId, className, this.props.customerName);
    };

    loadData = () => {
  		this.props.customerData.then((customerData) => {
            let gdpr = customerData.result && customerData.result.hasOwnProperty('gdprDoc') && customerData.result.gdprDoc && customerData.result.gdprDoc.length >0 ?
                customerData.result.gdprDoc.filter( (doc)=> {
                    return doc.lang === this.props.language;
                }) : null;
            gdpr = gdpr !== null ? (gdpr.length > 0 ? gdpr[gdpr.length -1] : customerData.result.gdprDoc[customerData.result.gdprDoc.length -1]) : null;
            this.setState({loading: false, title: customerData.result.name, gdpr: gdpr});

        }).catch(reason => {
            setTimeout(this.loadData, 1000);
        })
    };

    render() {
		let bannerBackgroundImg =  this.getStyle('banner-background-img');
    	if(this.state.loading === false)
    		bannerBackgroundImg = bannerBackgroundImg === "default" ? '/gate/images/default-banner.jpg' : 'src' in bannerBackgroundImg ? generateJobIconUrl(undefined, bannerBackgroundImg['src']) : null;
    	else
			bannerBackgroundImg = null;


        let {gdpr} = this.state;
        let customerLogo = this.getStyle('customer-logo');
        let customerTitle = this.getStyle('customer-title');

        return (
            <>
                <header className="header-2 fixed-top">
                    <div className="container">
                        <div className="row">
                            <div className="col">
                                <Navbar variant="light" bg="white" expand="lg">
                                    <Navbar.Brand style={{ height: '60px', width: 240 }}>
                                        {customerLogo.src && (!customerLogo.display || customerLogo.display !== "none") ? (
                                            <Link to={this.props.link || '/'+this.props.language+'/gate/'+this.props.customerName+'/positions'}>
                                                <img src={generateJobIconUrl(undefined, customerLogo.src)} className="img-fluid" style={customerLogo}/>
                                            </Link>
                                        ) : ( (!customerTitle.display || customerTitle.display !== "none") && (
                                            <div style={{ display: 'flex', height: '100%', flexDirection: 'column', justifyContent: 'center' }}>
                                                <h5 style={{...{ whiteSpace: 'normal', lineHeight: 1.2 }, ...customerTitle }}>
                                                    <Link to={this.props.link || '/'+this.props.language+'/gate/'+this.props.customerName+'/positions'}>{this.state['title']}</Link>
                                                </h5>
                                            </div>
                                        ))}
                                    </Navbar.Brand>
                                    <Navbar.Toggle aria-controls="navbarSupportedContent"/>
                                    <Navbar.Collapse id="navbarSupportedContent">
                                        <Nav className="ml-auto mb-5 mb-lg-0 navbar-nav">
                                            <Nav.Item>
                                                <Link to={this.props.link || '/'+this.props.language+'/gate/'+this.props.customerName+'/positions'} className="nav-link">
                                                    <i className={"fa fa-fw fa-home"}/> {window.Translator.getSlug('Vacancies', this.props.language)}
                                                </Link>
                                            </Nav.Item>
                                            {!this.props.isAgency && (
                                                <>
                                                    <NavGdprComponent
                                                        language={this.props.language}
                                                        customer={this.props.customerName}
                                                        gdpr={gdpr}
                                                    />
                                                    <NavUserComponent
                                                        language={this.props.language}
                                                        customerName={this.props.customerName}
                                                        userName={this.props.userName}
                                                    />
                                                </>)}
                                            <NavLanguageComponent language={this.props.language} />
                                        </Nav>
                                    </Navbar.Collapse>
                                </Navbar>
                            </div>
                        </div>
                    </div>
                </header>
                {bannerBackgroundImg &&
                <img src={bannerBackgroundImg} alt={bannerBackgroundImg} className={"banner-background-img"}/>}
            </>
        );
    }
}
